// ページネーション情報を取得
const scriptTag = document.getElementById("collection-products-json");
const totalPages = parseInt(scriptTag.dataset.totalPages || 1);

// 全ページのデータを取得する関数
async function loadAllProducts() {
  // Liquid `collections[handle].products` は最大50件しか返さない制限があるため、
  // インラインの初期データは使わず、page 1 から JSON エンドポイントで全件取得する。
  const fetchPromises = [];
  for (let page = 1; page <= totalPages; page++) {
    const url = `/collections/raingutter_lp?view=raingutterjson&page=${page}`;
    fetchPromises.push(
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then((data) => data.products || [])
        .catch(() => [])
    );
  }

  const allPages = await Promise.all(fetchPromises);
  raingutterProducts = allPages.flat();

  initializeFilter();
}

// 絞り込み機能を初期化する関数
function initializeFilter() {
  const delivery = ["個人様", "法人様"];
  const place = ["住宅", "カーポート(エクステリア用)", "大型雨とい・非住宅"];
  const type = [
    "たてとい（竪樋）",
    "たて継手（竪継手）",
    "エルボ",
    "ドレン",
    "曲り",
    "止まり",
    "チーズ",
    "軒樋（軒とい）",
    "軒継手",
    "集水器",
    "ます",
    "大型雨どい",
    "雨どい固定用金具類",
    "アタッチメント",
    "サドル",
    "ジャバラ",
    "その他",
  ];
  const shape = ["丸樋（丸とい）", "角樋（角とい）", "大型雨樋"];
  const manufacturer = [
    "パナソニック （ナショナル）",
    "セキスイ （エスロン）",
    "その他 （汎用品）",
  ];
  const size = [
    "30×45",
    "32",
    "37",
    "42",
    "45",
    "55",
    "60",
    "75",
    "90",
    "100",
    "105",
    "120",
    "Archi-spec TOI AG120",
    "Archi-spec TOI 45",
    "サーフェスケア FS-Ⅱ FS-Ⅰ",
    "KAKU 85",
    "ファインスケア NF-1",
    "グランスケア PGR60",
    "シビルスケア PC50",
    "シビルスケア PC77",
    "ジェイスケア PJ70",
    "パラスケア U105",
    "アイアン角 N3.5Ⅱ",
    "アートフェイス VM120",
    "アーバントップ Σ90",
    "新・丸トップ RV105",
    "PC30",
    "S30",
    "瞬水 S15",
    "アートフェイス Y60H",
    "前高130WIDE",
    "前高165WIDE",
    "折版120Ⅰ",
    "折版150Ⅰ",
    "折版150Ⅱ",
    "折版200Ⅰ",
    "Chic Line CL60",
    "Chic Line CL89",
    "Chic Line CL114",
    "超芯V型 V200",
    "超芯V型 V300",
  ];
  const color = [
    "ミルクホワイト",
    "パールグレー（白）",
    "ねずみ",
    "シルバーグレー",
    "あか",
    "しんちゃ",
    "ブラック",
    "オークグレー",
    "ココアブラウン",
    "ステンシルバー",
    "アイボリー",
    "モダンベージュ",
    "オークブラウン",
    "ディープブラウン",
    "スレートブラック",
    "マットシルバー",
    "マットホワイト",
    "マットブラウン",
    "マットブラック",
    "マットグレー",
    "クロ",
    "シンチャ",
    "ホワイト",
    "ウォームベージュ",
    "シルバーメタリック",
    "アーバングレー",
    "シルバー",
    "グレー",
    "タフグレー",
    "ココア",
    "クリーム",
    "ダークグレー",
    "ファインメタリック",
    "ブラック（エクステリア用）",
    "ブロンズ（エクステリア用）",
    "グレー（エクステリア用）",
    "ホワイト（エクステリア用）",
    "色なし",
  ];

  const selected = {
    delivery: [],
    place: [],
    type: [],
    shape: [],
    manufacturer: [],
    size: [],
    color: [],
  };

  let filtered = [...raingutterProducts];

  // ページネーション用の変数
  const ITEMS_PER_PAGE = 50; // 1ページあたりの表示件数
  let currentDisplayCount = ITEMS_PER_PAGE; // 現在表示している件数

  const count = document.querySelector(".result h2 .count");
  const filter = () => {
    filtered = [...raingutterProducts];

    // 絞り込み実行時に表示件数をリセット
    currentDisplayCount = ITEMS_PER_PAGE;

    const byDelivery =
      selected.delivery.length > 0
        ? filtered.filter((item) =>
            item.metafields.delivery.some((delivery) => selected.delivery.includes(delivery))
          )
        : filtered;
    const byPlace =
      selected.place.length > 0
        ? byDelivery.filter((item) =>
            item.metafields.place.some((place) => selected.place.includes(place))
          )
        : byDelivery;
    const byType =
      selected.type.length > 0
        ? byPlace.filter((item) =>
            item.metafields.type.some((type) => selected.type.includes(type))
          )
        : byPlace;
    const byShape =
      selected.shape.length > 0
        ? byType.filter((item) =>
            item.metafields.shape.some((shape) => selected.shape.includes(shape))
          )
        : byType;
    const byManufacturer =
      selected.manufacturer.length > 0
        ? byShape.filter((item) =>
            item.metafields.manufacturer.some((manufacturer) =>
              selected.manufacturer.includes(manufacturer)
            )
          )
        : byShape;
    const bySize =
      selected.size.length > 0
        ? byManufacturer.filter((item) =>
            item.metafields.size.some((size) => selected.size.includes(size))
          )
        : byManufacturer;
    const byColor =
      selected.color.length > 0
        ? bySize.filter((item) =>
            item.metafields.color.some((color) => selected.color.includes(color))
          )
        : bySize;
    filtered = byColor;
    updateView();
  };
  const updateView = () => {
    count.textContent = filtered.length;
    updateSelected();
    updateFound();
  };
  const updateSelected = () => {
    const selectedList = document.querySelector(".result ul.selected");
    selectedList.innerHTML = "";
    Object.keys(selected).forEach((key) => {
      selected[key].forEach((item) => {
        const li = document.createElement("li");
        li.textContent = item;
        li.dataset.selectType = key;
        selectedList.appendChild(li);
      });
    });
  };
  const updateFound = () => {
    const foundList = document.querySelector(".result ul.found");
    foundList.innerHTML = "";

    // 現在の表示件数分だけ表示
    const displayItems = filtered.slice(0, currentDisplayCount);

    displayItems.forEach((item) => {
      const li = document.createElement("li");
      const link = document.createElement("a");
      link.href = item.url;
      const image = document.createElement("div");
      image.classList.add("image");
      // featured_image 未設定の商品は img を生成しない (壊れ画像アイコン回避)
      if (item.image) {
        const img = document.createElement("img");
        img.src = item.image;
        image.appendChild(img);
      }
      link.appendChild(image);
      const text = document.createElement("div");
      text.classList.add("text");
      text.textContent = item.title;
      link.appendChild(text);
      li.appendChild(link);
      foundList.appendChild(li);
    });

    // 「もっと見る」ボタンの表示/非表示を制御
    updateLoadMoreButton();
  };

  const updateLoadMoreButton = () => {
    const loadMoreButton = document.querySelector(".result .load-more-button");
    if (!loadMoreButton) return;

    // まだ表示していない商品がある場合はボタンを表示
    if (currentDisplayCount < filtered.length) {
      loadMoreButton.style.display = "block";
      const remaining = filtered.length - currentDisplayCount;
      const nextLoad = Math.min(remaining, ITEMS_PER_PAGE);
      loadMoreButton.textContent = `さらに${nextLoad}件を表示`;
    } else {
      loadMoreButton.style.display = "none";
    }
  };

  // 「もっと見る」ボタンのクリックイベント
  const loadMoreButton = document.querySelector(".result .load-more-button");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", () => {
      // 表示件数を増やす
      currentDisplayCount += ITEMS_PER_PAGE;
      // 表示を更新
      updateFound();
    });
  }

  filter();

  const allList = document.querySelectorAll(".select-content-item");
  allList.forEach((item) => {
    item.addEventListener("click", (e) => {
      const parent = e.target.closest("ul");
      const selectType = parent.dataset.selectType;
      const selectedItem = e.target.querySelector(".text").textContent.trim();
      if (selected[selectType].includes(selectedItem)) {
        e.target.classList.remove("active");
        selected[selectType] = selected[selectType].filter((item) => item !== selectedItem);
      } else {
        e.target.classList.add("active");
        selected[selectType].push(selectedItem);
      }
      const currentStep = parent.closest("li");
      const nextStep = currentStep.nextElementSibling;
      const result = document.querySelector("section.result");
      if (nextStep) {
        currentStep.nextElementSibling.scrollIntoView({
          behavior: "smooth",
        });
      } else {
        result.scrollIntoView({
          behavior: "smooth",
        });
      }
      filter();
    });
  });

  const popup = document.querySelector(".popup");
  const popupSize = document.querySelector(".popup.size");
  const popupClose = document.querySelectorAll(".popup .box .close");
  popupClose.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.currentTarget.closest(".popup").classList.remove("active");
    });
  });

  const popupOpen = document.querySelectorAll(".popup-open");
  popupOpen.forEach((item) => {
    item.addEventListener("click", (e) => {
      const popupType = item.closest(".popup-open").classList.contains("damage")
        ? "damage"
        : "size";
      if (popupType === "size") {
        popupSize.classList.add("active");
      } else {
        popup.classList.add("active");
      }
    });
  });

  const resultHeadingWrapper = document.querySelector(".result .heading-wrapper");
  const resultHeading = resultHeadingWrapper.querySelector("h2");
  const resultHeadingHeight = resultHeading.getBoundingClientRect().height;
  const resultHeadingTop = resultHeading.getBoundingClientRect().top + window.scrollY;

  resultHeading.addEventListener("click", (e) => {
    resultHeadingWrapper.scrollIntoView({
      behavior: "smooth",
    });
  });

  const step1List = document.querySelector("main section ol.search > li:nth-child(1) > ul");
  const step1ListTop = step1List.getBoundingClientRect().top + window.scrollY;
  const step1ListHeight = step1List.getBoundingClientRect().height;
  const betweenStep1AndResult = resultHeadingTop - (step1ListTop + step1ListHeight);

  window.addEventListener("scroll", (e) => {
    const scrollY = window.scrollY;
    const isSelected = Object.keys(selected).filter((key) => selected[key].length > 0).length > 0;
    if (!isSelected) {
      return;
    }
    if (scrollY + window.innerHeight > resultHeadingTop + 60) {
      resultHeading.classList.remove("fixed");
    } else {
      if (scrollY + window.innerHeight > step1ListTop + resultHeadingHeight + step1ListHeight) {
        resultHeading.classList.remove("stopped");
        resultHeading.style.transform = "";
      } else {
        resultHeading.classList.add("stopped");
        resultHeading.style.transform = `translateY(-${betweenStep1AndResult}px)`;
      }
      resultHeading.classList.add("fixed");
    }
  });

  const scrollTop = document.querySelector(".scroll-top");
  scrollTop.addEventListener("click", (e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  let scrollAmount = 0;
  window.addEventListener("scroll", (e) => {
    scrollAmount = window.scrollY;
  });
  setInterval(() => {
    if (scrollAmount > 0) {
      scrollTop.classList.add("active");
    } else {
      scrollTop.classList.remove("active");
    }
  }, 500);
} // initializeFilter() の終了

// ページ読み込み後に全商品データを取得開始
loadAllProducts();
